"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.isReassignmentConfirmationJobReceivablesPayloadConfig = exports.isReceivableResponseTapePreviewPayloadConfig = exports.isAssignmentConfirmationJobPayloadConfig = exports.isDefaultPreviewEmailPayloadConfig = exports.isSingleReceivableResponseTapePreviewPayloadConfig = exports.isReceivableResponseTapePreviewsFromStrategyPayloadConfig = exports.hasSanitizedNormalizedRepaymentInputFields = exports.isInternalAssignedRepaymentTape = exports.isInternalRepaymentTape = exports.isLoanTapeType = void 0;
const _ = __importStar(require("lodash"));
const schema = __importStar(require("../schema"));
const typeguardUtils_1 = require("./typeguardUtils");
const loanTapeTypes = {
    masterLoanTape: 'masterLoanTape',
    preassignedLoanTape: 'preassignedLoanTape',
    preassignedMasterLoanTape: 'preassignedMasterLoanTape',
};
const isLoanTapeType = (str) => _.values(loanTapeTypes).indexOf(str) !== -1;
exports.isLoanTapeType = isLoanTapeType;
exports.isInternalRepaymentTape = (0, typeguardUtils_1.typeguardFunctionLogWrapper)({
    schema: schema.InternalRepaymentTapeSchema,
    typeguardName: 'isInternalRepaymentTape',
});
exports.isInternalAssignedRepaymentTape = (0, typeguardUtils_1.typeguardFunctionLogWrapper)({
    schema: schema.InternalAssignedRepaymentTapeSchema,
    typeguardName: 'isInternalAssignedRepaymentTape',
});
exports.hasSanitizedNormalizedRepaymentInputFields = (0, typeguardUtils_1.typeguardFunctionLogWrapper)({
    schema: schema.SanitizedNormalizedRepaymentInputFieldsSchema,
    typeguardName: 'hasSanitizedNormalizedRepaymentInputFields',
});
exports.isReceivableResponseTapePreviewsFromStrategyPayloadConfig = (0, typeguardUtils_1.typeguardFunctionLogWrapper)({
    schema: schema.ReceivableResponseTapePreviewsFromStrategyPayloadSchema,
    typeguardName: 'isReceivableResponseTapePreviewsFromStrategyPayloadConfig',
});
exports.isSingleReceivableResponseTapePreviewPayloadConfig = (0, typeguardUtils_1.typeguardFunctionLogWrapper)({
    schema: schema.SingleReceivableResponseTapePreviewPayloadSchema,
    typeguardName: 'isSingleReceivableResponseTapePreviewPayloadConfig',
});
exports.isDefaultPreviewEmailPayloadConfig = (0, typeguardUtils_1.typeguardFunctionLogWrapper)({
    schema: schema.DefaultPreviewEmailPayloadSchema,
    typeguardName: 'isDefaultPreviewEmailPayloadConfig',
});
exports.isAssignmentConfirmationJobPayloadConfig = (0, typeguardUtils_1.typeguardFunctionLogWrapper)({
    schema: schema.AssignmentConfirmationJobPayloadSchema,
    typeguardName: 'isAssignmentConfirmationJobPayloadConfig',
});
exports.isReceivableResponseTapePreviewPayloadConfig = (0, typeguardUtils_1.typeguardFunctionLogWrapper)({
    schema: schema.ReceivableResponseTapePreviewPayloadSchema,
    typeguardName: 'isReceivableResponseTapePreviewPayloadConfig',
});
exports.isReassignmentConfirmationJobReceivablesPayloadConfig = (0, typeguardUtils_1.typeguardFunctionLogWrapper)({
    schema: schema.ReassignmentConfirmationJobReceivablesPayloadSchema,
    typeguardName: 'isReassignmentConfirmationJobReceivablesPayloadConfig',
});
//# sourceMappingURL=loanProduct.js.map